/**
 * API Configuration
 * Centralized backend URL management
 */

/**
 * Get the backend URL dynamically
 * @returns {string} The backend URL
 */
export const getBackendUrl = () => {
  // In production, always use REACT_APP_BACKEND_URL
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  
  // In development, use REACT_APP_BACKEND_URL or fallback to localhost
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
};

/**
 * Get the frontend/widget base URL
 * Widget HTML files are served from the same domain as the app
 * @returns {string} The frontend base URL
 */
export const getFrontendUrl = () => {
  // Always use the current origin where the app is running
  // Dev: https://health-metrics-94.preview.emergentagent.com
  // Prod: https://bookingflows.com
  return window.location.origin;
};

/**
 * The backend base URL
 * @type {string}
 */
export const BACKEND_URL = getBackendUrl();

/**
 * The frontend base URL (for widgets)
 * @type {string}
 */
export const FRONTEND_URL = getFrontendUrl();

/**
 * The API base URL (backend + /api)
 * @type {string}
 */
export const API_URL = `${BACKEND_URL}/api`;

// Only log in development
if (process.env.NODE_ENV === 'development') {
  console.log('🚀 API Configuration:', {
    BACKEND_URL,
    FRONTEND_URL,
    API_URL
  });
}

export default {
  BACKEND_URL,
  FRONTEND_URL,
  API_URL,
  getBackendUrl,
  getFrontendUrl
};